import { render } from "./transition-triggers-modal.vue?vue&type=template&id=349330a3&ts=true"
import script from "./transition-triggers-modal.ts?vue&type=script&lang=ts&external"
export * from "./transition-triggers-modal.ts?vue&type=script&lang=ts&external"

import "./transition-triggers-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__